/**
 * Контроллер подтверждения контакта в форме.
 * Делегирует отображение модалки и сетевые запросы в MoK.showVerifCode,
 */
const confirmContact = function ({
        form = null,
        formName: FORM_NAME,
        type: TYPE,
        callBack: successCodeCallBack,
        onlyConfirm = false,
        debug = false
} = {}) {
        if (!form) {
                form = $(`form[name="${FORM_NAME}"]`);
        }
        if (!form.length) {
                debug && console.error("Не найдена Форма " + FORM_NAME);
                return;
        }

        const btn = form.find(`input[data-type="${TYPE}-code-btn"]`);
        if (!btn.length) {
                debug && console.error("Не найдена кнопка " + TYPE);
                return;
        }

        const submitBtn = form.find('input[type="submit"], button[type="submit"], button:not([type])');
        const LENGTH = parseInt(btn.attr('data-length')) || 4;
        const INTERVAL = parseInt(btn.attr('data-interval')) || 60;

        let contactInput = null;
        let validateFunc = null;
        let maskMethod = null;
        let actionText = "";
        let descriptionText = "";

        switch (TYPE) {
                case 'phone':
                        contactInput = form.find('input[name="phone"]');
                        validateFunc = (typeof validatePhone !== 'undefined') ? validatePhone : () => true;
                        maskMethod = (typeof maskPhone !== 'undefined') ? maskPhone : (v) => v;
                        actionText = 'Подтверждение номера телефона';
                        descriptionText = 'Введите код, отправленный по SMS на номер телефона ';
                        break;
                case 'email':
                        contactInput = form.find('input[name="email"]');
                        validateFunc = (typeof validateEmail !== 'undefined') ? validateEmail : () => true;
                        maskMethod = (typeof maskEmail !== 'undefined') ? maskEmail : (v) => v;
                        actionText = 'Подтверждение почты';
                        descriptionText = 'Введите код, отправленный на электронную почту ';
                        break;
                case 'new_email':
                        contactInput = form.find('input[name="new_email"]');
                        validateFunc = (typeof validateEmail !== 'undefined') ? validateEmail : () => true;
                        maskMethod = (typeof maskEmail !== 'undefined') ? maskEmail : (v) => v;
                        actionText = 'Изменение почты';
                        descriptionText = 'Введите код, отправленный на электронную почту ';
                        break;
                default:
                        debug && console.error("Неизвестный тип: " + TYPE);
                        return;
        }

        if (!contactInput || !contactInput.length) {
                debug && console.error("Не найден contact input для типа " + TYPE);
                return;
        }

        const CONFIRM_CLASS = 'verifCode__input--confirm';
        let oldContactValue = '';
        setTimeout(() => oldContactValue = contactInput.val().trim(), 0); // ждем inputTel



        function btnCancelModule() {
                const btnCancel = $(`<div class="verifCode__cancel" title="Отменить изменения"><span></span><span></span></div>`);
                const inputContainer = form.find(`.verifCode__input-container[data-type="${TYPE}"]`);
                return {
                        insert: () => {
                                inputContainer.append(btnCancel);
                                btnCancel.on('click', function () {
                                        const currentMaskedValue = contactInput.val().trim();

                                        contactInput
                                                .prop("readonly", true)
                                                .addClass(CONFIRM_CLASS)
                                                .attr('data-edit', "false")
                                                .val(currentMaskedValue);

                                        btn.val("Изменить");

                                        const editContactInputs = form.find('input[data-edit="true"]');
                                        if (editContactInputs.length === 0) {
                                                submitBtn.prop('disabled', false);
                                        }

                                        btnCancel.remove();
                                });
                        },
                        remove: () => btnCancel.remove(),
                        click: () => btnCancel.trigger('click')
                };
        }
        const btnCancel = btnCancelModule();
        // ============================================

        // Обработчик клика по кнопке "Подтвердить" / "Изменить"
        btn.click(function (e) {
                e.preventDefault();

                // Логика переключения в режим редактирования
                if (TYPE !== 'new_email' && btn.val() === 'Изменить' && !onlyConfirm) {
                        contactInput
                                .prop("readonly", false)
                                .removeClass(CONFIRM_CLASS)
                                .attr('data-edit', "true");
                        submitBtn.prop('disabled', true);
                        btn.val("Подтвердить");

                        btnCancel.insert(); // Вставляем крестик отмены
                        return;
                }

                // Защита от ввода старой почты при смене email
                if (TYPE === 'new_email' && contactInput.val().trim() === form.find('input[name="email"]').val().trim()) {
                        contactInput.val(contactInput.val().trim()); // убираем пробелы
                        btnCancel.click(); // Эмулируем клик по крестику для отмены изменений
                        return;
                }

                // Базовая валидация перед открытием модалки
                const currentVal = contactInput.val().trim();

                if (!currentVal) {
                        aAlert("Введите значение!");
                        contactInput.focus();
                        return;
                }

                // если значение не изменилось ===
                if (currentVal === oldContactValue) {
                        btnCancel.click(); // Эмулируем клик по крестику, отменяем изменения, модалка НЕ откроется
                        return;
                }
                // ============================================================

                if (!validateFunc(currentVal)) {
                        aAlert("Некорректное значение!");
                        contactInput.focus();
                        return;
                }

                // вызов модалки
                MoK.showVerifCode({
                        type: TYPE,
                        contactValue: currentVal,
                        maskMethod: maskMethod,
                        length: LENGTH,
                        interval: INTERVAL,
                        title: actionText,
                        descriptionText: descriptionText,
                        onSuccess: (result) => {
                                contactInput.prop('readonly', true).addClass(CONFIRM_CLASS).attr('data-edit', "false");

                                const editContactInputs = form.find('input[data-edit="true"]');
                                if (editContactInputs.length === 0) {
                                        submitBtn.prop('disabled', false);
                                }

                                if (onlyConfirm) {
                                        btn.remove();
                                } else {
                                        btn.val("Изменить");
                                        btnCancel.remove();
                                }

                                if (successCodeCallBack && typeof successCodeCallBack === 'function') {
                                        successCodeCallBack({
                                                form: form,
                                                contactInput: contactInput,
                                                btn: btn,
                                                submitBtn: submitBtn,
                                                code: result.code,
                                                contactValue: result.contactValue,
                                                oldContactValue: oldContactValue
                                        });
                                }
                                oldContactValue = contactInput.val().trim();
                        }
                });
        });
};

/**
* Добавление обработчиков событий для inputs, где вводим код подтверждения
* Может использоваться отдельно от confirmContact
* (например, где другой механизм подтверждения. пример в email_code.html)
* @param arguments[0] - объект с параметрами
* @note inputsContainer - dom-контейнер для инпутов
* @note callback - колбек, работающий после полного ввода формы - необязательный
* @note getEveryCodeChange - если false то возвращаем только полностью введенный код, иначе будем отслеживать каждую цифру
* @return object - возвращает методы для работы с inputs
*/
function setupConfirmCodeInputs({ container: inputsContainer, callback: callback, getEveryCodeChange = false }) {
        if (!inputsContainer) {
                console.error("Не найден inputsContainer " + inputsContainer);
                return;
        }

        const inputs = inputsContainer.querySelectorAll('input[maxlength="1"]'); // получаем через нативный DOM
        if (!inputs) {
                console.error("Не найдены inputs " + inputsContainer);
                return;
        }

        inputs.forEach((input, idx) => {
                input.addEventListener('input', (e) => {
                        const value = e.target.value;

                        // Разрешаем только цифры
                        if (!/^\d*$/.test(value)) {
                                e.target.value = '';
                                return;
                        }

                        // Если введена цифра, переходим к следующему полю
                        if (value && idx < inputs.length - 1) {
                                inputs[idx + 1].focus();
                        }

                        // Проверяем полноту заполнения
                        checkComplete(inputs);
                });

                // Обработка Backspace
                input.addEventListener('keydown', (e) => {
                        if (e.key === 'Backspace') {
                                // Если поле пустое и это не первое поле
                                if (!input.value && idx > 0) {
                                        // Переходим к предыдущему полю и очищаем его
                                        inputs[idx - 1].focus();
                                        inputs[idx - 1].value = '';

                                        if (getEveryCodeChange) { // если каждую цифру возвращаем то при удалении тоже проверяем
                                                checkComplete(inputs);
                                        }
                                }
                        }
                });

                // Обработка вставки из буфера
                input.addEventListener('paste', (e) => {
                        e.preventDefault();
                        const pastedData = e.clipboardData.getData('text');
                        const digits = pastedData.replace(/\D/g, ''); // Только цифры

                        // Заполняем поля начиная с текущего
                        for (let i = 0; i < digits.length && (idx + i) < inputs.length; i++) {
                                inputs[idx + i].value = digits[i];
                        }

                        // Устанавливаем фокус на следующее незаполненное поле или последнее
                        const nextEmptyIndex = Math.min(idx + digits.length, inputs.length - 1);
                        inputs[nextEmptyIndex].focus();

                        // Проверяем полноту заполнения
                        checkComplete(inputs);
                });
        });

        // Функция проверки полного заполнения
        function checkComplete(inputs) {
                const allFilled = Array.from(inputs).every(input => input.value.trim() !== '');

                if (allFilled || getEveryCodeChange) {
                        const code = Array.from(inputs).map(input => input.value).join('');

                        if (callback && typeof callback === 'function') {
                                callback(code);
                        }

                }
        }

        return {
                clear: () => { // очистить значение
                        inputs.forEach(input => input.value = '');
                        inputs[0]?.focus();
                },
                getValue: () => Array.from(inputs).map(input => input.value).join(''), // получить значение
                focus: () => inputs[0]?.focus() // фокус
        };
};
